import dayjs from "dayjs";
import _ from "lodash";

export const gettabId = sessionStorage.getItem("tabId");
export const gettabId2 = sessionStorage.getItem("tabId2");
export const setSessionData = (keyId, value) =>
  sessionStorage.setItem(keyId, value);
export const getSessionData = (keyId) => sessionStorage.getItem(keyId);
export const removeSessionData = (keyId) => sessionStorage.removeItem(keyId);

export const rowPerPage = 50;
export const antTableScroll = { x: true };

export const baseB4Key = 'data:image/jpeg;base64,';

export const roleList = ['', 'Admin', 'User', '', 'Super Admin']

export const adminRole = '1'
export const userRole = '2'
export const superAdminRole = '4'

export const addKey = 'Add'
export const updateKey = 'Update'
export const incomeTypeList = ['Flat', 'Percentage']

export const pinTypeList = {1: 'Active',
  2: 'InActive'}

export const walletTypeKey = 'WALLETTYPE'
export const MLMPlanTypeKey = 'MLMPLANTYPE'
export const PinRegistrationEnableKey = 'PIN_REGISTRATION_ENABLE'
export const LevelIncomeTypeKey = 'LEVEL_INCOME_TYPE'
export const matchingBonusPlanTypeKey = "MATCHINGBONUS"
export const levelPlanTypeKey = "LEVEL"
export const singleLegPlanTypeKey = "SINGLELEG"
export const autoPoolPlanTypeKey = "AUTOPOOL"
export const GiveLinkTypeKey = "GiveLink"
export const TakeLinkTypeKey = "TakeLink"

export const appConfigKeyList = [PinRegistrationEnableKey, LevelIncomeTypeKey]
export const planTypeList = [matchingBonusPlanTypeKey, levelPlanTypeKey, singleLegPlanTypeKey, autoPoolPlanTypeKey]

export const urlFixer = (url, role) => {
  if (url) {
    if (role === superAdminRole) {
      return _.join(['', 'superAdmin', url], '/')
    } else if (role === adminRole) {
      return _.join(['', 'admin', url], '/')
    } else {
      return _.join(['', 'user', url], '/')
    }
  }
}

export const transactionTypeList = [
  { key: "All", value: "All", id: "All", title: "All Status", label: "All Status" },
  { key: "0", value: "0", id: "0", title: "Pending", label: "Pending" },
  { key: "1", value: "1", id: "1", title: "Success", label: "Success" },
  { key: "2", value: "2", id: "2", title: "Failed", label: "Failed" },
];

export const titleArray = [
  {id: '0', title: 'Mr'},
  {id: '1', title: 'Mrs'},
  {id: '2', title: 'Miss'},
]

export const dateFormat = "YYYY-MM-DD";
export const dateTime12Format = "YYYY-MM-DD hh:mm A";
export const dateTime12ssFormat = "YYYY-MM-DD hh:mm:ss A";
export const dateTime24Format = "YYYY-MM-DD HH:mm";
export const dateTime24ssFormat = "YYYY-MM-DD HH:mm:ss";

export const getTodayDate = () => {
  const date = dayjs().format(dateFormat);
  return date;
};

export const popButtonDefaultIcon = (
  <i className="bi bi-question-circle-fill fs-4 me-2 text-warning" />
);
export const popButtonDefaultTitile = "Confirmation";
export const popButtonDefaultDesc = (val = "") =>
  `Are you sure to ${val || "perform this action"}.`;
export const popButtonStatusIcon = (
  <i className="bi bi-exclamation-circle-fill fs-4 me-2 text-warning" />
);
export const popButtonStatusTitile = "Change Status";
export const popButtonStatusDesc = (val = "") =>
  `Are you sure to change ${val || "this data"} status.`;
export const popButtonDeleteIcon = (
  <i className="bi bi-question-circle-fill fs-4 me-2 text-warning" />
);
export const popButtonDeleteTitile = "Delete data";
export const popButtonDeleteDesc = (val = "") =>
  `Are you sure to delete ${val || "this data"}.`;

export const ellipsisButtonTitle = "View More";

export const transectionType = [
  { id: "credit", title: "credit" },
  { id: "debit", title: "debit" },
];


// style light color
export const darkTextColor = '#fff'
export const darkBgColor = '#fff'

// style dark color
export const lightTextColor = '#000'
export const lightBgColor = '#000'

export const reportDefaultStatus = [0,1,2,3,4,5]
export const defaultPageSize = 50
export const defaultPageNumber = 1

export const reportType = ["MatchingSponsorBonus_Income", "MatchingBonus_Income"]
export const incomeType = ["MatchingBonus_Income", "EarlyBird_Royalty_Income", "Royalty_Income"]

export const levelIncomeType = [
  {id: 'AUTOPOOL', key: 'AUTOPOOL', label: 'AUTOPOOL', title: 'AUTOPOOL'},
  {id: 'AUTOPOOL1', key: 'AUTOPOOL1', label: 'AUTOPOOL1', title: 'AUTOPOOL1'},
  {id: 'AUTOPOOL2', key: 'AUTOPOOL2', label: 'AUTOPOOL2', title: 'AUTOPOOL2'},
]